import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('radiogroup');

export { TAG_NAME };
